/* src/app/modules/shared/components/header-column/header-column-energy-score/header-column-energy-score.component.scss */
app-header-column-energy-score {
  display: contents;
}
/*# sourceMappingURL=header-column-energy-score.component.css.map */
